/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiMiniToolRequest,
  CreateAiMiniToolRequestInput,
  ListAiMiniToolRequestsParams,
  PaginatedAiMiniToolRequests,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of AI MiniToolRequests
 */
export const listAiMiniToolRequests = (
    params?: MaybeRefOrGetter<ListAiMiniToolRequestsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiMiniToolRequests>(
      {url: `/ai/mini_tool_requests`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiMiniToolRequestsQueryKey = (params?: MaybeRefOrGetter<ListAiMiniToolRequestsParams>,) => {
    return [
    'ai','mini_tool_requests', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiMiniToolRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiMiniToolRequestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMiniToolRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMiniToolRequests>>> = ({ signal }) => listAiMiniToolRequests(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData>
}

export type ListAiMiniToolRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMiniToolRequests>>>
export type ListAiMiniToolRequestsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI MiniToolRequests
 */

export function useListAiMiniToolRequests<TData = Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiMiniToolRequestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiMiniToolRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI MiniToolRequest
 */
export const deleteMiniToolRequest = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/mini_tool_requests/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteMiniToolRequestMutationKey = () => ['deleteMiniToolRequest'] as const;

export const getDeleteMiniToolRequestMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,DeleteMiniToolRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,DeleteMiniToolRequestMutationVariables, TContext> => {

const mutationKey = getDeleteMiniToolRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMiniToolRequest>>, DeleteMiniToolRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteMiniToolRequest(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMiniToolRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMiniToolRequest>>>

    export type DeleteMiniToolRequestMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteMiniToolRequestMutationVariables = {id: string}

    /**
 * @summary Delete AI MiniToolRequest
 */
export const useDeleteMiniToolRequest = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,DeleteMiniToolRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMiniToolRequest>>,
        TError,
        DeleteMiniToolRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteMiniToolRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Create AI MiniToolRequest
 */
export const createMiniToolRequest = (
    miniToolId: MaybeRefOrGetter<string>,
    createAiMiniToolRequestInput: MaybeRefOrGetter<CreateAiMiniToolRequestInput>,
 signal?: AbortSignal
) => {
      miniToolId = toValue(miniToolId);
createAiMiniToolRequestInput = toValue(createAiMiniToolRequestInput);

      return axiosClient<AiMiniToolRequest>(
      {url: `/ai/mini_tools/${miniToolId}/mini_tool_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiMiniToolRequestInput, signal
    },
      );
    }




export const getCreateMiniToolRequestMutationKey = () => ['createMiniToolRequest'] as const;

export const getCreateMiniToolRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,CreateMiniToolRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,CreateMiniToolRequestMutationVariables, TContext> => {

const mutationKey = getCreateMiniToolRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMiniToolRequest>>, CreateMiniToolRequestMutationVariables> = (props) => {
          const {miniToolId,data} = props ?? {};

          return  createMiniToolRequest(miniToolId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMiniToolRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createMiniToolRequest>>>
    export type CreateMiniToolRequestMutationBody = CreateAiMiniToolRequestInput
    export type CreateMiniToolRequestMutationError = ErrorType<void>
    export type CreateMiniToolRequestMutationVariables = {miniToolId: string;data: CreateAiMiniToolRequestInput}

    /**
 * @summary Create AI MiniToolRequest
 */
export const useCreateMiniToolRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,CreateMiniToolRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMiniToolRequest>>,
        TError,
        CreateMiniToolRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMiniToolRequestMutationOptions(options), queryClient);
    }
